import { notesPendingActionActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import { log } from '_services'

const initialState = {
    selectedMessage: undefined,
    loading: false,
    deleting: false
};

export const reducer = createReducer(initialState, {
    [notesPendingActionActions.setSelectedMessage]: (state, action) => {
        state.selectedMessage = action.payload.noteId;
    },
    [notesPendingActionActions.markReadFailure]: (state, action) => {
        log.error('Error marking note as read. noteId: ' + action.payload.noteId + ' error: ' + action.payload.error);
    },
    [notesPendingActionActions.loadRequest]: (state, action) => {
        state.loading = true;
    },
    [notesPendingActionActions.loadSuccess]: (state, action) => {
        state.loading = false;
        state.selectedMessage = undefined;
    },
    [notesPendingActionActions.loadFailure]: (state, action) => {
        state.loading = false;
        state.selectedMessage = undefined;
        log.error('Error loading notes pending action. error: ' + action.payload.error);
    },
    [notesPendingActionActions.deleteAllRequest]: (state, action) => {
        state.deleting = true;
    },
    [notesPendingActionActions.deleteAllSuccess]: (state, action) => {
        state.deleting = false;
        state.selectedMessage = undefined;
    },
    [notesPendingActionActions.deleteAllFailure]: (state, action) => {
        state.deleting = false;
        state.selectedMessage = undefined;
        log.error('Error deleting all approved messages: ' + action.payload.noteIds.join(', ') + ' error: ' + action.payload.error);
    },
    [notesPendingActionActions.deleteSuccess]: (state, action) => {
        state.selectedMessage = undefined;
    },
    [notesPendingActionActions.deleteFailure]: (state, action) => {
        state.deleting = false;
        state.selectedMessage = undefined;
        log.error('Error deleting message. noteId: ' + action.payload.noteId + ' error: ' + action.payload.error);
    },

})


